export default "City Bowling Holbæk har flere forskellige aktiviteter ud over bowling. De åbnede deres første escape room i marts 2022.";